import { GridColDef } from "@mui/x-data-grid";
import { TbUser } from "react-icons/tb";

import ClipBoard from "@/components/ClipBoard";
import { TableHeader } from "@/components/TableHeader";
import { User } from "@/types/user.types";

function RenderCell({ value }: { value: string }) {
    return (
        <div className=" font-medium flex items-center h-full pl-2 text-sm   break-all">
            <ClipBoard text={value}>{value}</ClipBoard>
        </div>
    );
}
export const UserNameColumn = (): GridColDef<User> => {
    return {
        field: "userName",
        headerName: "userName",
        minWidth: 180,
        valueGetter: (_value, row) => row.userName,
        renderHeader: (params) => <TableHeader Component={TbUser} title={params.colDef.headerName!} />,
        renderCell: ({ value }) => <RenderCell value={value} />,
    };
};
